import React, { useEffect } from "react";
import { compose } from "redux";
import withTranslations from "../../../../../hocs/withTranslations";
import config from "../../../../../config";
import AnalyticsEventTracker from "../../../../../lib/AnalyticsEventTracker";
import NewModal from "../../NewModal";

function ExpalertsRegisterModal({ translate, hideModal, trigger }) {
  useEffect(() => {
    AnalyticsEventTracker.trackRegistrationModalEvent(trigger || "user_action");
  }, [trigger]);

  return (
    <NewModal
      title={translate("In order to complete this action you have to sign up.")}
      acceptButtonText={translate("Register")}
      hideOnAccept={false}
      onAccept={() => {
        window.open(config.registerUrl, "_blank");
      }}
      hideModal={hideModal}
    />
  );
}

export default compose(withTranslations)(ExpalertsRegisterModal);
